/** ข้อความไทยของกฎที่เซิร์ฟเวอร์ปฏิเสธ Scan-In/Scan-Out ที่เกี่ยวกับเครื่องและลำดับขั้นตอน */

const RULE_TEXT: Readonly<Record<string, string>> = {
  MACHINE_SCAN_REQUIRED: 'ต้องสแกน QR ที่เครื่องอย่างน้อย 1 เครื่องก่อนเริ่มผลิต',
  MACHINE_QR_INVALID: 'QR ของเครื่องอ่านไม่ได้หรือผิดรูปแบบ — สแกน QR ที่ติดบนเครื่องใหม่',
  MACHINE_NOT_FOUND: 'ไม่พบเครื่องนี้ในระบบ — ตรวจว่าเป็น QR ของโรงงานนี้',
  MACHINE_INACTIVE: 'เครื่องนี้ถูกปิดใช้งานแล้ว — ใช้เครื่องอื่นหรือแจ้งผู้ดูแลข้อมูลหลัก',
  MACHINE_NOT_IN_WORK_CENTER: 'เครื่องนี้ไม่ได้อยู่ใน work center ของขั้นตอนนี้',
  PREVIOUS_OPERATION_HAS_NO_OUTPUT: 'ขั้นก่อนหน้ายังไม่มีของดีออก — ทำขั้นก่อนก่อน',
  EXCEEDS_PREVIOUS_OPERATION_OUTPUT: 'จำนวนเกินของดีที่ขั้นก่อนหน้าส่งมา',
  NOTHING_LEFT_FROM_PREVIOUS_OPERATION: 'ของดีจากขั้นก่อนถูกใช้ครบแล้ว',
};

export interface ShopFloorRuleDetails {
  readonly previous_good?: unknown;
  readonly already_at_this_step?: unknown;
  readonly requested?: unknown;
}

export function shopFloorRuleText(rule: string): string | null {
  return RULE_TEXT[rule] ?? null;
}

/** รวมตัวเลขจาก details (สตริงทศนิยม) เมื่อมี — ไม่แปลงเป็น Number */
export function shopFloorRuleTextWithDetails(rule: string, details?: ShopFloorRuleDetails): string | null {
  if (
    (rule === 'EXCEEDS_PREVIOUS_OPERATION_OUTPUT' || rule === 'NOTHING_LEFT_FROM_PREVIOUS_OPERATION') &&
    details !== undefined
  ) {
    const { previous_good: good, already_at_this_step: done } = details;
    if (typeof good === 'string' && typeof done === 'string') {
      const counts = `ขั้นก่อนมีของดี ${good} ชิ้น ขั้นนี้ทำไปแล้ว ${done} ชิ้น`;
      return rule === 'EXCEEDS_PREVIOUS_OPERATION_OUTPUT' ? counts : `${RULE_TEXT[rule]} — ${counts}`;
    }
  }
  return shopFloorRuleText(rule);
}
